import React, { useCallback, useEffect, useState } from "react";

import { getUserNotificationSettings } from "services";

import { getLocalKlimVar, useCancelAsyncOnUnmount, useNavigate, useParams, useToggleNavs, useTranslation, useUserContext } from "utils";

import { Col, ErrorBoundary, MainPage, NavigationHeader, Row } from "components";

import { ProfileNotificationSetting } from "pages/app/user/components/ProfileNotificationSetting";

export const ProfileNotifications = () => {
  const { t } = useTranslation(["user", "meta"]);
  const { user } = useUserContext();
  const { userId } = useParams();

  useToggleNavs(false, false);

  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState({});
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadUserSettings = useCallback(() => {
    setLoading(true);

    getUserNotificationSettings({
      token: getLocalKlimVar("token") || userId,
      signal,
    })
      .then((res) => {
        setDetails(res);
      })
      .catch((_err) => {
        navigate("/sign-in");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [navigate, userId, signal]);

  useEffect(() => {
    loadUserSettings();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"profile"} containerClass="tiny">
      {user && <NavigationHeader title={t("notifications.headerTitle")} />}
      <Row>
        <Col>
          <h2> {t("notifications.title")} </h2>
          <p style={{ maxWidth: "768px" }}>{t("notifications.description")}</p>
        </Col>
      </Row>
      <ErrorBoundary>
        <ProfileNotificationSetting details={details} userId={userId} iconName={"tabler/messages"} setLoading={setLoading} setting={"forum"} t={t} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ProfileNotificationSetting details={details} userId={userId} iconName={"tabler/wallet"} setLoading={setLoading} setting={"wallet"} t={t} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ProfileNotificationSetting
          details={details}
          userId={userId}
          iconName={"tabler/tractor"}
          setLoading={setLoading}
          setting={"documentation"}
          t={t}
          hp={user.hp}
        />
      </ErrorBoundary>
      <ErrorBoundary>
        <ProfileNotificationSetting details={details} userId={userId} iconName={"tabler/news"} setLoading={setLoading} setting={"content"} t={t} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ProfileNotificationSetting details={details} userId={userId} iconName={"tabler/ad-2"} setLoading={setLoading} setting={"news"} t={t} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ProfileNotificationSetting details={details} userId={userId} iconName={"tabler/mail"} setLoading={setLoading} setting={"newsletter"} t={t} />
      </ErrorBoundary>
    </MainPage>
  );
};
